import React from 'react';

function EmptySearch () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="92"
      height="100"
      fill="none"
      viewBox="0 0 92 100"
    >
      <path
        fill="#B4DCD9"
        fillRule="evenodd"
        d="M60.31 73.966l-6.91-6.842 3.76-3.722 6.91 6.842-3.76 3.722z"
        clipRule="evenodd"
      />
      <path
        fill="#96C6C2"
        fillRule="evenodd"
        d="M62.721 71.579l1.348-1.335-6.91-6.842-1.347 1.335 6.91 6.842z"
        clipRule="evenodd"
      />
      <path
        stroke="#4AA49D"
        strokeWidth="0.5"
        d="M53.4 67.124l6.91 6.842m-3.15-10.564l6.91 6.842"
      />
      <path
        fill="#CFEDEB"
        fillRule="evenodd"
        d="M32.955 18.177c-13.933 0-25.228 11.184-25.228 24.98 0 13.797 11.295 24.981 25.228 24.981 13.934 0 25.229-11.184 25.229-24.98 0-13.797-11.295-24.98-25.229-24.98zM1.063 43.157c0-17.44 14.279-31.578 31.892-31.578 17.614 0 31.893 14.138 31.893 31.579 0 17.44-14.28 31.579-31.893 31.579S1.063 60.598 1.063 43.157z"
        clipRule="evenodd"
      />
      <path
        fill="#96C6C2"
        fillRule="evenodd"
        d="M63.773 35C60.141 21.513 47.72 11.579 32.955 11.579c-.32 0-.638.005-.955.014v6.602c.317-.012.636-.018.955-.018 11.049 0 20.438 7.032 23.853 16.823h6.965z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        stroke="#4AA49D"
        strokeWidth="0.5"
        d="M32.955 18.177c-13.933 0-25.228 11.184-25.228 24.98 0 13.797 11.295 24.981 25.228 24.981 13.934 0 25.229-11.184 25.229-24.98 0-13.797-11.295-24.98-25.229-24.98zM1.063 43.157c0-17.44 14.279-31.578 31.892-31.578 17.614 0 31.893 14.138 31.893 31.579 0 17.44-14.28 31.579-31.893 31.579S1.063 60.598 1.063 43.157z"
        clipRule="evenodd"
      />
      <path
        fill="#EDFEFD"
        fillRule="evenodd"
        d="M85.149 98.846a3 3 0 01-4.222 0L59.491 77.62a2 2 0 010-2.842l5.426-5.373a2 2 0 012.814 0l21.423 21.212a3 3 0 010 4.263l-4.005 3.966z"
        clipRule="evenodd"
      />
      <path
        fill="#C1E6E2"
        fillRule="evenodd"
        d="M88.235 95.79L63.253 71.051l1.67-1.653a2 2 0 012.808.006l21.423 21.211a3 3 0 010 4.264l-.919.91z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        stroke="#4AA49D"
        strokeWidth="0.5"
        d="M85.149 98.846a3 3 0 01-4.222 0L59.491 77.62a2 2 0 010-2.842l5.426-5.373a2 2 0 012.814 0l21.423 21.212a3 3 0 010 4.263l-4.005 3.966z"
        clipRule="evenodd"
      />
      <path
        fill="#EDFEFD"
        fillRule="evenodd"
        d="M46.373 1.205a3 3 0 00-3 3v30.144a3 3 0 003 3H69.1v5.809l5.866-5.809h12.396a3 3 0 003-3V4.205a3 3 0 00-3-3H46.374z"
        clipRule="evenodd"
      />
      <path
        fill="#4AA49D"
        d="M69.1 37.35h.25v-.25h-.25v.25zm0 5.808h-.25v.6l.426-.422-.176-.178zm5.866-5.809v-.25h-.103l-.073.073.176.177zM43.624 4.205a2.75 2.75 0 012.75-2.75v-.5a3.25 3.25 0 00-3.25 3.25h.5zm0 30.144V4.205h-.5v30.144h.5zm2.75 2.75a2.75 2.75 0 01-2.75-2.75h-.5a3.25 3.25 0 003.25 3.25v-.5zm22.726 0H46.374v.5H69.1v-.5zm.25 6.059v-5.809h-.5v5.809h.5zm5.44-5.986l-5.866 5.808.352.356 5.866-5.809-.352-.355zm12.572-.073H74.966v.5h12.396v-.5zm2.75-2.75a2.75 2.75 0 01-2.75 2.75v.5a3.25 3.25 0 003.25-3.25h-.5zm0-30.144v30.144h.5V4.205h-.5zm-2.75-2.75a2.75 2.75 0 012.75 2.75h.5a3.25 3.25 0 00-3.25-3.25v.5zm-40.988 0h40.988v-.5H46.374v.5z"
      />
      <path
        fill="#6EB7B1"
        fillRule="evenodd"
        stroke="#4AA49D"
        strokeLinecap="round"
        strokeWidth="0.5"
        d="M60.53 12.568a1.606 1.606 0 012.256 0l4.72 4.673 4.719-4.673a1.606 1.606 0 012.255 0 1.568 1.568 0 010 2.233l-4.72 4.673 4.72 4.673a1.568 1.568 0 010 2.233 1.606 1.606 0 01-2.255 0l-4.72-4.673-4.719 4.673a1.606 1.606 0 01-2.255 0 1.568 1.568 0 010-2.233l4.72-4.673-4.72-4.673a1.568 1.568 0 010-2.233z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default EmptySearch;
